import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/data/issues/:issueId");

export const Route = createFileRoute("/data/issues/$issueId")({
  head: () => ({
    meta: [
      { title: "Data feed issue — LevelLoad" },
      { name: "description", content: "The rows behind one reported data feed issue." },
      { property: "og:title", content: "Data feed issue — LevelLoad" },
      {
        property: "og:description",
        content: "The rows behind one reported data feed issue.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
